module.exports = __webpack_public_path__ + "static/media/md-trash.2141e00a.svg";